import React from "react";
import { BASE_URL } from "../../constants";
import teamCareer from "../../assets/our_teams/TeamCareer.png";
import noCurrentJob from "../../assets/our_teams/NoCurrentOpenings.png";
import ContactForm from "../ContactForm/ContactForm";
import Header from "../Helper/Header";
import NewFooter from "../Helper/NewFooter";
import { useNavigate } from "react-router-dom";

const opportunities = [
    // {
    //     id: "Dsr0014",
    //     title: "Research Engineer (Chemical Engineer)",
    //     location: "India, Remote",
    //     position: "Entry Level (1-3 years)",
    //     postedOn: "Sep 03rd 2025"
    // },
    // {
    //     id: "Dsr0022",
    //     title: "Backend Engineer",
    //     location: "India, Remote",
    //     position: "Intermediate Level (3-5 years)",
    //     postedOn: "Sep 03rd 2025"
    // },
    // {
    //     id: "Dsr0020",
    //     title: "UX Designer",
    //     location: "India, Remote",
    //     position: "Intermediate Level (3+ years)",
    //     postedOn: "May 27, 2026"
    // },
    // {
    //     id: "Dsr0023",
    //     title: "Frontend Engineer",
    //     location: "India, Remote",
    //     position: "Intermediate Level (3+ years)",
    //     postedOn: "Sep 12th 2025"
    // },
    // {
    //     id: "Dsr0010",
    //     title: "Senior Frontend Engineer",
    //     location: "India, Remote",
    //     position: "Senior Level (6+ years)",
    //     postedOn: "Sep 24th 2025"
    // }
    // {
    //     id: "Dsr0026",
    //     title: "Director of Engineering – India",
    //     location: "India, Remote",
    //     position: "Senior Level - Reports to CEO",
    //     postedOn: "January 28, 2026"
    // }
    {
        id: "Dsr0027",
        title: "Data Analytics Engineer",
        location: "United States | Remote",
        position: "Intermediate Level (3+ years)",
        postedOn: "August 21, 2026"
    },
];

const CareerPage = () => {
    const navigate = useNavigate();
    return (
        <>
            <Header />
            <div className="max-w-6xl mx-auto px-4 py-12">
                {/* Header */}
                <div className="packages-container">
                    <h1 className="corecomp-heading" style={{ marginTop: "0px" }}>Opportunities
                        <img
                            src={`${BASE_URL}common-images/mask_image.png
                    `}
                            alt="Mask"
                            className="mask-image"
                        /></h1>
                    <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
                        We believe in fostering a dynamic and collaborative work <br /> environment
                        that empowers our team to create digital excellence.
                    </p>
                </div>

                {/* Image Grid */}

                <div className="row">
                        <div className="team__wrapper">
                                    <img
                                        src={`${BASE_URL}our_teams/JobPost.jpg`}
                                        alt="Dsider"
                                        style={{maxWidth: "700px"}}
                                    />
                    </div>
                </div>
                {/* Openings */}
                <div className="packages-container">
                    <h1 className="inteplanheading" style={{ marginTop: "2rem" }}>Current Openings</h1>
                    <p className="text-gray-800 mt-4">
                        If you think you might be a good fit for our team, we'd love to hear
                        from you!
                    </p>

                    {/* If no current openings are available, we will display a message and an image.
                    Comment or uncomment the job details section based on the requirement. */}

                    {/* <div className="team__thumb">
                        <img
                            style={{ width: "100%", height: "200px" }}
                            src={`${BASE_URL}our_teams/NoCurrentOpenings.png`}
                            //src={noCurrentJob}
                            alt="Dsider"
                        />
                    </div>
                    <p className="text-gray-800 mt-4">
                        Sorry! there are no openings right now, stay tuned for future opportunities
                    </p> */}
                </div>
                {/* Job Details goes below -- Comment/Uncomment it based on the requirement  */}
                <div className="space-y-6">
                    {opportunities.map((job) => (
                        <div key={job.id} className="job-card-container">
                            <div className="job-card-content">

                                <div className="job-info">
                                    <h3 className="job-title">{job.title}</h3>
                                    <div className="job-meta">
                                        <span><strong>Location:</strong> {job.location}</span>
                                        <span><strong>Position:</strong> {job.position}</span>
                                        <span><strong>Posted on:</strong> {job.postedOn}</span>
                                    </div>
                                </div>

                                <div>
                                    <a
                                        href={`/Careers/Jobs/${job.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="mt-auto z-btn-blog view-more-btn z-btn-3"
                                    >
                                        View More
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* WHY JOIN DSIDER SECTION */}
                <div className="packages-container">
                    <h1 className="inteplanheading" >WHY JOIN DSIDER?
                        <img
                            src={`${BASE_URL}common-images/mask_image.png
                    `}
                            alt="Mask"
                            className="mask-image"
                        /></h1>
                    <div className="packages-container">
                        {/* First Row */}
                        <div className="row">
                            <div className="package-item">
                                <h3 className="text-lg font-semibold mb-2">Innovative Work Environment</h3>
                                <p className="package-text">
                                    Immerse yourself in a culture of innovation, where your ideas are not just welcomed but encouraged.
                                    Dsider is a place where creativity flourishes.
                                </p>
                            </div>

                            <div className="package-item">
                                <h3 className="text-lg font-semibold mb-2">Career Growth</h3>
                                <p className="package-text">
                                    We invest in our team’s professional development.We are committed to helping you reach your career goals.
                                </p>
                            </div>

                            <div className="package-item">
                                <h3 className="text-lg font-semibold mb-2">Collaborative Team</h3>
                                <p className="package-text">
                                    Join a team that values collaboration. At Dsider, we believe that great ideas come from diverse minds working together towards a common vision.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <ContactForm showFooter={false} />
            <NewFooter />
        </>
    );
};

export default CareerPage;
